var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 123",
    d: "M30 0L55.9808 15V45L30 60L4.01924 45V15L30 0Z",
    fill: "#847609",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 39H42L30 18L18 39ZM31.0909 35.6842H28.9091V33.4737H31.0909V35.6842ZM31.0909 31.2632H28.9091V26.8421H31.0909V31.2632Z",
    fill: "#FFE664"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.8e3f782bc4b1a55ef248e36afa4b577c.svg";
export { ForwardRef as ReactComponent };